module.exports = __webpack_public_path__ + "media/images/bg-header-final-96a06b0d.png";